import {
  Stack,
  VStack,
} from "@chakra-ui/react";
import NewEmployeeButtonWithModal from "components/ModalForm/NewEmployeeButtonWithModal";
import WorkforceTable from "components/Table/WorkforceTable";
import WorkforceTableFilters, { WorkforceTableFiltersType } from "components/Table/WorkforceTableFilters";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import { useEffect, useState } from "react";
import { useSelectedUserId } from "features/User/hooks/useSelectedUserId";
import { EditProfileModal } from "features/User/Components/EditProfileModal";
import { UpdateRolesModal } from "features/User/Components/UpdateRolesModal";
import { DeactivateUserConfirm } from "features/User/Components/DeactivateUserConfirm";

const defaultFilters: WorkforceTableFiltersType = {
  q: undefined,
  show_deactivated: undefined,
};

export default function WorkforcePage() {
  const [filters, setFilters] = useState<WorkforceTableFiltersType>(defaultFilters);
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  // User action modals
  const editProfile = useSelectedUserId();
  const updateRoles = useSelectedUserId();
  const deactivate = useSelectedUserId();

  useEffect(() => {
    setPageTitle("Workforce");
    // setBackLocationName("Home");
    // setBackLocationPath("/");
    return () => {
      setPageTitle(null);
      setBackLocationName(null);
      setBackLocationPath(null);
    };
  }, [setBackLocationName, setBackLocationPath, setPageTitle]);

  return (
    <AppPage>
      <VStack spacing={4} alignItems="stretch">
        <VStack spacing={4} alignItems="stretch">
          <Stack
            direction="row"
            w="100%"
            justifyContent="flex-end"
          >
            <NewEmployeeButtonWithModal />
          </Stack>
          <WorkforceTableFilters
            filters={filters}
            onFiltersChange={setFilters}
            onReset={() => setFilters(defaultFilters)}
          />
        </VStack>
        <WorkforceTable
          filters={filters}
          onEditProfile={editProfile.selectUserId}
          onUpdateRoles={updateRoles.selectUserId}
          onDeactivate={deactivate.selectUserId}
        />
      </VStack>

      {/* User action modals */}
      <EditProfileModal userId={editProfile.selectedUserId} onClose={editProfile.clearUserId} />
      <UpdateRolesModal userId={updateRoles.selectedUserId} onClose={updateRoles.clearUserId} />
      <DeactivateUserConfirm userId={deactivate.selectedUserId} onClose={deactivate.clearUserId} />
    </AppPage>
  );
}
